<div class="forum-page">
  <!-- Feed social e forum desativados.
  <app-community-tabs context="forum"></app-community-tabs>
  -->

  <div class="forum-layout">
    <!-- ░░ Sidebar esquerda: comunidades ░░ -->
    <aside class="forum-rail forum-rail--left">
      <div class="forum-rail__card">
        <h2 class="forum-rail__title">Comunidades</h2>
        <button
          class="forum-comm"
          *ngFor="let c of communities"
          (click)="openCommunity(c)"
        >
          <span class="forum-comm__icon" [style.background]="c.color">
            <i [class]="c.icon"></i>
          </span>
          <span class="forum-comm__text">
            <span class="forum-comm__name">{{ c.name }}</span>
            <span class="forum-comm__members">{{ short(c.members) }} membros</span>
          </span>
        </button>
      </div>
    </aside>

    <!-- ░░ Coluna principal ░░ -->
    <main class="forum-main">
      <!-- Composer trigger + ordenação -->
      <div class="forum-compose-bar">
        <div class="forum-compose-avatar">VC</div>
        <button class="forum-compose-input" (click)="openComposer()">
          Criar um post na comunidade…
        </button>
        <button class="forum-compose-btn" (click)="openComposer()">
          <i class="pi pi-plus"></i> Novo post
        </button>
      </div>

      <div class="forum-sortbar">
        <button class="forum-sort" [class.forum-sort--active]="sort === 'hot'" (click)="setSort('hot')">
          <i class="pi pi-bolt"></i> Em alta
        </button>
        <button class="forum-sort" [class.forum-sort--active]="sort === 'new'" (click)="setSort('new')">
          <i class="pi pi-clock"></i> Recentes
        </button>
        <button class="forum-sort" [class.forum-sort--active]="sort === 'top'" (click)="setSort('top')">
          <i class="pi pi-chart-bar"></i> Top
        </button>
      </div>

      <!-- Lista de posts -->
      <div class="forum-list">
        <app-forum-post-card *ngFor="let p of posts" [post]="p"></app-forum-post-card>
      </div>
    </main>

    <!-- ░░ Sidebar direita: sobre + regras ░░ -->
    <aside class="forum-rail forum-rail--right">
      <div class="forum-about">
        <div class="forum-about__head">
          <i class="pi pi-comments"></i>
          <span>Fórum FuelTech</span>
        </div>
        <p class="forum-about__desc">
          O ponto de encontro da comunidade do tuning. Tire dúvidas de acerto,
          mostre sua build e aprenda com quem coloca a mão na injeção.
        </p>
        <div class="forum-about__stats">
          <div class="forum-stat">
            <span class="forum-stat__num">{{ short(totalMembers) }}</span>
            <span class="forum-stat__label">membros</span>
          </div>
          <div class="forum-stat">
            <span class="forum-stat__num forum-stat__num--online">1,8k</span>
            <span class="forum-stat__label">online agora</span>
          </div>
        </div>
        <button class="forum-about__cta" (click)="openComposer()">
          <i class="pi pi-pencil"></i> Criar post
        </button>
      </div>

      <div class="forum-rules">
        <h3 class="forum-rules__title">Regras da comunidade</h3>
        <ol class="forum-rules__list">
          <li>Respeite todos os preparadores e iniciantes.</li>
          <li>Sem venda não autorizada de produtos.</li>
          <li>Compartilhe logs e arquivos ao pedir ajuda.</li>
          <li>Nada de incentivo a uso irregular em via pública.</li>
        </ol>
      </div>
    </aside>
  </div>
</div>

<!-- ░░ Composer modal ░░ -->
<p-dialog
  [(visible)]="composerVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="forum-composer-dialog"
  [style]="{ width: '92vw', maxWidth: '620px' }"
>
  <ng-template pTemplate="header">
    <div class="forum-composer__header">
      <i class="pi pi-pencil"></i> Criar um post
    </div>
  </ng-template>

  <div class="forum-composer">
    <label class="forum-composer__label">Comunidade</label>
    <div class="forum-composer__communities">
      <button
        *ngFor="let c of communities"
        class="forum-composer__comm"
        [class.forum-composer__comm--active]="draftCommunityId === c.id"
        (click)="draftCommunityId = c.id"
      >
        <span class="forum-composer__comm-icon" [style.background]="c.color"><i [class]="c.icon"></i></span>
        {{ c.name }}
      </button>
    </div>

    <label class="forum-composer__label">Tipo</label>
    <div class="forum-composer__tags">
      <button
        *ngFor="let t of tagOptions"
        class="forum-composer__tag"
        [class.forum-composer__tag--active]="draftTag === t"
        (click)="draftTag = t"
      >
        {{ t }}
      </button>
    </div>

    <label class="forum-composer__label">Título</label>
    <input
      type="text"
      class="forum-composer__input"
      [(ngModel)]="draftTitle"
      maxlength="140"
      placeholder="Seja específico — ex: 'FT600 não lê sensor de fase no AP'"
    />

    <label class="forum-composer__label">Conteúdo</label>
    <textarea
      class="forum-composer__textarea"
      [(ngModel)]="draftBody"
      maxlength="5000"
      rows="5"
      placeholder="Descreva sua dúvida, build ou discussão. Quanto mais detalhe, melhor a resposta."
    ></textarea>
  </div>

  <ng-template pTemplate="footer">
    <button class="forum-composer__cancel" (click)="composerVisible = false">Cancelar</button>
    <button class="forum-composer__submit" [disabled]="!canSubmit" (click)="submitPost()">
      <i class="pi pi-send"></i> Publicar
    </button>
  </ng-template>
</p-dialog>
